import { Grid, Link, Typography } from "@mui/material";
import * as React from 'react';

import { ContextStore } from '../store/contextStore';

const MESSAGES = {
    400: "Can't load data",
    401: "Please login again",
    403: "Access denied",
    404: "not found",
    405: "Method not allowed",
    406: "Validation failed",
    500: "Server error",
    502: "Server restarts, please try again in a few minutes",
    503: "Service unavailable",
}

function getErrorMessage(code) {
    return MESSAGES[code] ? MESSAGES[code] : "Error (code: " + code + ")";
}

export const HTTPError = (props) => {
    const { logout } = React.useContext(ContextStore);
    const handleLogout = (ev) => {
        logout();
    }
    
    const rc = props.resource.substr(0, 1).toUpperCase() + props.resource.substr(1).toLowerCase().replace('_', ' ');
    return (<Grid container alignItems="center" justifyContent="center" p={2} style={{ height: '100%' }}>
            <Typography textAlign="center">
            <p>{rc} {props.id}: {getErrorMessage(props.code)}</p>
            {(parseInt(props.code) === 404 || parseInt(props.code) === 400) && <>
                <p>
                    It is also possible that you do not have permission to view this page, please contact support for authorization change requests.
                </p>
                <p>
                    If you have authorization and believe that this message is in error, please <Link href="javascript:void(0)" onClick={handleLogout}>sign out</Link> and back in for reauthorization.
                </p>
            </>}
            </Typography>
    </Grid>)
}

export default HTTPError;
